

const zonas = {
    argentina: 'America/Argentina/Buenos_Aires',
    peru: 'America/Lima',
    mexico: 'America/Mexico_City',
    chile: 'America/Santiago',
    colombia: 'America/Bogota',
    brasil: 'America/Sao_Paulo',
    estadosUnidosEste: 'America/New_York',
    estadosUnidosCentro: 'America/Chicago',
    estadosUnidosPacifico: 'America/Los_Angeles',
    españa: 'Europe/Madrid',
    reinoUnido: 'Europe/London',
    alemania: 'Europe/Berlin',
    india: 'Asia/Kolkata',
    china: 'Asia/Shanghai',
    japon: 'Asia/Tokyo',
    australiaSydney: 'Australia/Sydney',
};

// Zona horaria activa
const zonaHoraria = zonas.mexico;

export default zonaHoraria;


